import React from 'react';

import './LoadingSpinner.css';

const sizeClassNames = {
  sm: 'c-loading-spinner--sm',
  md: 'c-loading-spinner--md',
  lg: 'c-loading-spinner--lg',
};

const LoadingSpinner = ({
  className = '',
  inline = false,
  label = '読み込み中',
  showLabel = false,
  size = 'md',
}) => {
  const sizeClassName = sizeClassNames[size] || sizeClassNames.md;
  const classNames = [
    'c-loading-spinner',
    sizeClassName,
    inline ? 'c-loading-spinner--inline' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <span className={classNames} role="status" aria-label={showLabel ? undefined : label}>
      <span className="c-loading-spinner__mark" aria-hidden="true" />
      {showLabel ? (
        <span className="c-loading-spinner__label">{label}</span>
      ) : (
        <span className="c-loading-spinner__label c-loading-spinner__label--hidden">{label}</span>
      )}
    </span>
  );
};

export default LoadingSpinner;
